export default __webpack_public_path__ + "static/media/en.8207606d.svg";